<template>
  <div>
    <div class="dovemed-card">
      <h3 class="fw700 font32 gray900 mt-4">DoveMed Recommended</h3>
      <div class="search-container w-100">
        <form @submit.prevent="" class="w-100 d-flex align-items-center searchContainer">
          <font-awesome-icon :icon="['fal', 'search']" :style="{ color: getPrimaryColor() }" @click="callDebounce" class="cp ml-3" />
          <input type="search" class="search-input-state w-100" placeholder="Search by name" v-model="searchName" @input="callDebounce" />
          <a-icon v-if="searchName" class="close-icon" type="close" :size="'large'" @click="handleClearSearch" />
        </form>
        <button @click="handlefilter" class="search-button primary-button position-relative">
          <img src="../../assets/icons/bars-filter-light.png" alt="filter icon" />
          <p class="apply show-in-mobile">Apply Filters</p>
          <div v-if="role !== undefined" class="active-filter-indicator" :style="{ background: getPrimaryColor() }" />
          <RecommendedFilterModal ref="recommendedFilterModal" :setCategory="setCategory" :role="role" :clearFilters="clearFilters" />
        </button>
      </div>
      <div v-if="role !== undefined" class="top_filters">
        <div class="filter-container">
          <div class="appliedFilter">Applied Filter:</div>
          <div v-if="role !== undefined" class="filterTypeBox">
            <div class="filterTypeText">{{ getrolename(role) }}</div>
            <!-- <i class="fa fa-times" aria-hidden="true" style="cursor: pointer" @click="clearFilters()"></i> -->
            <a-icon type="close" :size="'small'" class="cp" @click="clearFilters()" />
          </div>
        </div>
        <div class="clear-filters cp" :style="{ color: getPrimaryColor() }" @click="clearFilters">Clear Filters</div>
      </div>
    </div>

    <div
      v-if="
        (searchName &&
          !loading &&
          !loadingBusiness &&
          !loadingclinic &&
          !loadinghospital &&
          !loadingnfp &&
          !loadinghcp &&
          !DoctorsList.results.length &&
          !hcpList.results.length &&
          !HospitalList.results.length &&
          !ClinicList.results.length &&
          !NfpList.results.length &&
          !BusinessList.results.length) ||
          (!loadingfilter && role ? !filterList.results.length : false)
      "
      class="d-flex justify-content-center mt-4 mb-3"
    >
      <p>No Results Found</p>
    </div>

    <div v-if="role !== undefined">
      <div v-if="!loadingfilter && filterList.results.length > 0">
        <div>
          <p class="text-left results">
            <span>{{ filterCount }} {{ filterCount <= 1 ? "Result" : "Results" }}</span>
          </p>
        </div>
        <div class="mb-2" v-for="doctor in filterList.results" :key="doctor.id">
          <DirectoryCard :info="doctor" :type="'physician'" :fetchDoc="applyFilterRole" />
        </div>
      </div>
      <div v-if="!loadingfilter && filterList.results.length === 0 && searchName === undefined" class="d-flex justify-content-center mt-3 mb-3">
        <!-- <p>No Results Found</p> -->
      </div>
      <SimpleLoader v-if="loadingfilter" :name="'Filtered Results'" />
    </div>

    <div v-else>
      <!-- physicians card -->
      <template v-if="!loading">
        <div class="doctors-search-result" v-if="DoctorsList.results.length">
          <h4 class="recommended-title">Physicians</h4>
          <div class="mb-2" v-for="doctor in DoctorsList.results" :key="doctor.id">
            <DirectoryCard :info="doctor" :type="'physician'" :fetchDoc="getDoctors" />
          </div>
          <div class="phy-pagination-container" v-if="!loading && DoctorsList.results.length && PhyCount > 3">
            <span
              @click="
                () => {
                  // this.role = 'physician'
                  // this.applyFilterRole()
                  // this.$router.push({name:'DoveMedRecommendedFilter',params : { role : this.role }});
                  setCategory('physician')
                }
              "
            >
              <button class="pagination-btn" :style="{ color: getPrimaryColor() }">
                View {{ PhyCount ? intToString(PhyCount - 3) : "0" }} more Physicians
                <font-awesome-icon size="2x" class="mr-2" :style="{ transform: 'scale(0.7)', width: '30px', marginTop: '-4px', color: getPrimaryColor() }" :icon="['fa', 'arrow-right']" />
              </button>
            </span>
          </div>
        </div>
      </template>
      <SimpleLoader v-else :name="'Physicians'" />

      <!-- Medical Professionals card -->
      <div v-if="!loadinghcp">
        <div class="doctors-search-result" v-if="hcpList.results.length">
          <h4 class="recommended-title">Advanced Practice Providers</h4>
          <div class="mb-2" v-for="doctor in hcpList.results" :key="doctor.id">
            <DirectoryCard :info="doctor" :type="'hcp'" :fetchDoc="getHcp" />
          </div>
          <div class="phy-pagination-container" v-if="hcpList.results.length && hcpCount > 3">
            <span
              @click="
                () => {
                  // this.role = 'other healthcare'
                  // this.applyFilterRole()
                  setCategory('other healthcare')
                }
              "
            >
              <button class="pagination-btn" :style="{ color: getPrimaryColor() }">
                View {{ PhyCount ? intToString(PhyCount - 3) : "0" }} more Providers
                <font-awesome-icon size="2x" class="mr-2" :style="{ transform: 'scale(0.7)', width: '30px', marginTop: '-4px', color: getPrimaryColor() }" :icon="['fa', 'arrow-right']" />
              </button>
            </span>
          </div>
        </div>
      </div>
      <SimpleLoader v-else :name="'Providers'" />

      <!-- hospitals card -->
      <div v-if="!loadinghospital">
        <div class="doctors-search-result" v-if="HospitalList.results.length">
          <h4 class="recommended-title">Hospitals</h4>
          <div class="mb-2" v-for="doctor in HospitalList.results" :key="doctor.id">
            <DirectoryCard :info="doctor" :type="'hospital_administrator'" :fetchDoc="getHospital" />
          </div>
          <div class="phy-pagination-container" v-if="HospitalList.results.length && HospitalCount > 3">
            <span
              @click="
                () => {
                  // this.role = 'hospital'
                  // this.applyFilterRole()
                  setCategory('hospital')
                }
              "
            >
              <button class="pagination-btn" :style="{ color: getPrimaryColor() }">
                View {{ PhyCount ? intToString(PhyCount - 3) : "0" }} more Hospitals
                <font-awesome-icon size="2x" class="mr-2" :style="{ transform: 'scale(0.7)', width: '30px', marginTop: '-4px', color: getPrimaryColor() }" :icon="['fa', 'arrow-right']" />
              </button>
            </span>
          </div>
        </div>
      </div>
      <SimpleLoader v-else :name="'Hospitals'" />

      <!-- clinics card -->
      <div v-if="!loadingclinic">
        <div class="doctors-search-result" v-if="ClinicList.results.length">
          <h4 class="recommended-title">Clinics</h4>
          <div class="mb-2" v-for="doctor in ClinicList.results" :key="doctor.id">
            <DirectoryCard :info="doctor" :type="'clinic_administrator'" :fetchDoc="getClinic" />
          </div>
          <div class="phy-pagination-container" v-if="ClinicList.results.length && clinicCount > 3">
            <span
              @click="
                () => {
                  // this.role = 'clinic'
                  // this.applyFilterRole()
                  setCategory('clinic')
                }
              "
            >
              <button class="pagination-btn" :style="{ color: getPrimaryColor() }">
                View {{ clinicCount ? intToString(clinicCount - 3) : "0" }} more Clinics
                <font-awesome-icon size="2x" class="mr-2" :style="{ transform: 'scale(0.7)', width: '30px', marginTop: '-4px', color: getPrimaryColor() }" :icon="['fa', 'arrow-right']" />
              </button>
            </span>
          </div>
        </div>
      </div>
      <SimpleLoader v-else :name="'Clinics'" />

      <!-- nfp card -->
      <div v-if="!loadingnfp">
        <div class="doctors-search-result" v-if="NfpList.results.length">
          <h4 class="recommended-title">Non-For-Profits</h4>
          <div class="mb-2" v-for="doctor in NfpList.results" :key="doctor.id">
            <DirectoryCard :info="doctor" :type="'nfp_administrator'" :fetchDoc="getNfp" />
          </div>
          <div class="phy-pagination-container" v-if="NfpList.results.length && NfpCount > 3">
            <span
              @click="
                () => {
                  this.role = 'nfp'
                  this.applyFilterRole()
                }
              "
            >
              <button class="pagination-btn" :style="{ color: getPrimaryColor() }">
                View {{ NfpCount ? intToString(NfpCount - 3) : "0" }} more Non-For-Profit
                <font-awesome-icon size="2x" class="mr-2" :style="{ transform: 'scale(0.7)', width: '30px', marginTop: '-4px', color: getPrimaryColor() }" :icon="['fa', 'arrow-right']" />
              </button>
            </span>
          </div>
        </div>
      </div>
      <SimpleLoader v-else :name="'NFPs'" />

      <!-- Business card -->
      <div v-if="!loadingBusiness">
        <div class="doctors-search-result" v-if="BusinessList.results.length">
          <h4 class="recommended-title">Business</h4>
          <div class="mb-2" v-for="doctor in BusinessList.results" :key="doctor.id">
            <DirectoryCard :info="doctor" :type="'Business'" :fetchDoc="getBusiness" />
          </div>
          <div class="phy-pagination-container" v-if="BusinessList.results.length && BusinessCount > 3">
            <span
              @click="
                () => {
                  // this.role = 'Business'
                  // this.applyFilterRole()
                  setCategory('Business')
                }
              "
            >
              <button class="pagination-btn" :style="{ color: getPrimaryColor() }">
                View {{ NfpCount ? intToString(BusinessCount - 3) : "0" }} more Business
                <font-awesome-icon size="2x" class="mr-2" :style="{ transform: 'scale(0.7)', width: '30px', marginTop: '-4px', color: getPrimaryColor() }" :icon="['fa', 'arrow-right']" />
              </button>
            </span>
          </div>
        </div>
      </div>
      <SimpleLoader v-else :name="'Business'" />
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
import RecommendedFilterModal from "../Modals/DoveMedRecommendedFIlterModal.vue"
import medicalDirectoryRepository from "../../repositories/medicalDirectoryRepository"
import userRepository from "../../repositories/userRepository"
import DirectoryCard from "./provider/DoveMedRecommendedCard.vue"
import ReviewStar from "../Users/Doctor/reviewstarforcircle.vue"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faThumbsUp, faCrown } from "@fortawesome/pro-solid-svg-icons"
import SimpleLoader from "../commons/SimpleLoader.vue"

library.add(faThumbsUp, faCrown)
export default {
  name: "DoveMedRecommended",
  components: {
    RecommendedFilterModal,
    ReviewStar,
    DirectoryCard,
    SimpleLoader,
  },
  data() {
    return {
      limit: 3,
      countphy: 0,
      imagesrc: "",
      role: undefined,
      DoctorsList: { results: [] },
      hcpList: { results: [] },
      ClinicList: { results: [] },
      HospitalList: { results: [] },
      NfpList: { results: [] },
      BusinessList: { results: [] },
      filterList: { results: [] },
      filterpageno: 1,
      searchName: undefined,
      loading: true,
      loadinghcp: true,
      loadingclinic: true,
      loadinghospital: true,
      loadingnfp: true,
      loadingBusiness: true,
      loadingfilter: false,
      PhyCount: undefined,
      hcpCount: undefined,
      clinicCount: undefined,
      HospitalCount: undefined,
      NfpCount: undefined,
      BusinessCount: undefined,
      filterCount: undefined,
      currentPage: 1,
      role: undefined,
    }
  },
  created() {
    console.warn("DoveMedRecommended.vue is created")
    this.getDoctors()
    this.getHcp()
    this.getClinic()
    this.getHospital()
    this.getNfp()
    this.getBusiness()
  },
  mounted() {
    this.role = undefined
    this.setVariablesFromQuery()
  },
  watch: {
    "$route.query.role": {
      handler() {
        if (this.$route.query.role === undefined) {
          this.role = undefined
          this.getDoctors()
          this.getHcp()
          this.getClinic()
          this.getHospital()
          this.getNfp()
          this.getBusiness()
        }
      },
    },
    role: {
      handler() {
        this.handlePathQuery("role")
      },
    },
  },
  methods: {
    setVariablesFromQuery() {
      Object.keys(this.$route.query).forEach(key => {
        if (this.$route.query[key]) {
          this[key] = this.$route.query[key]
        }
      })
    },
    handlePathQuery(v) {
      this.$router
        .replace({
          ...this.$route,
          query: {
            ...this.$route.query,
            [v]: this[v],
          },
        })
        .catch(e => {})
    },
    handlefilter() {
      this.$refs.recommendedFilterModal.Show(this.role)
    },
    intToString(num) {
      num = num.toString().replace(/[^0-9.]/g, "")
      if (num < 1000) {
        return num
      }
      let si = [
        { v: 1e3, s: "K" },
        { v: 1e6, s: "M" },
        { v: 1e9, s: "B" },
        { v: 1e12, s: "T" },
        { v: 1e15, s: "P" },
        { v: 1e18, s: "E" },
      ]
      let index
      for (index = si.length - 1; index > 0; index--) {
        if (num >= si[index].v) {
          break
        }
      }
      return (num / si[index].v).toFixed(2).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, "$1") + si[index].s
    },
    async getDoctors(name) {
      console.warn("getDoctors()")
      let page = 1
      document.body.scrollTop = 0
      this.loading = true
      const payload = {
        northEast: { lat: 57.539416794474995, lng: -62.05078125000001 },
        northWest: { lat: 57.539416794474995, lng: -128.67187500000003 },
        southEast: { lat: 15.029685756555674, lng: -62.05078125000001 },
        southWest: { lat: 15.029685756555674, lng: -128.67187500000003 },
        precision: "2000km",
        numberOfBuckets: 1000,
        filters: { is_recommended: "true", item_type: "physician" },
      }
      payload.circle_id = this.currentCircle.id
      if (this.searchName) {
        payload.filters.search_name = name ? name : this.searchName
      }

      medicalDirectoryRepository
        .PostMedicalDirectorySearch(this.currentPage, 3, this.currentCircle.id, "distance", payload)
        .then(res => {
          if (res.data.results) {
            this.DoctorsList.results = res.data.results
          } else {
            this.DoctorsList.results = []
          }
          this.PhyCount = res.data.totalResults
          this.loading = false
        })
        .catch(err => {
          this.DoctorsList.results = []
          this.loading = false
        })
    },
    async getHcp(name) {
      console.warn("getHcp()")
      let page = 1
      document.body.scrollTop = 0
      this.loadinghcp = true
      const payload = {
        northEast: { lat: 57.539416794474995, lng: -62.05078125000001 },
        northWest: { lat: 57.539416794474995, lng: -128.67187500000003 },
        southEast: { lat: 15.029685756555674, lng: -62.05078125000001 },
        southWest: { lat: 15.029685756555674, lng: -128.67187500000003 },
        precision: "2000km",
        numberOfBuckets: 1000,
        filters: { is_recommended: "true", item_type: "other healthcare" },
      }
      payload.circle_id = this.currentCircle.id
      if (this.searchName) {
        payload.filters.search_name = name ? name : this.searchName
      }
      medicalDirectoryRepository
        .PostMedicalDirectorySearch(this.currentPage, 3, this.currentCircle.id, "distance", payload)
        .then(res => {
          if (res.data.results) {
            this.hcpList.results = res.data.results
          } else {
            this.hcpList.results = []
          }
          this.hcpCount = res.data.totalResults
          this.loadinghcp = false
        })
        .catch(err => {
          this.hcpList.results = []
          this.loadinghcp = false
        })
    },
    async getClinic(name) {
      console.warn("getClinic()")
      let page = 1
      document.body.scrollTop = 0
      this.loadingclinic = true
      const payload = {
        northEast: { lat: 57.539416794474995, lng: -62.05078125000001 },
        northWest: { lat: 57.539416794474995, lng: -128.67187500000003 },
        southEast: { lat: 15.029685756555674, lng: -62.05078125000001 },
        southWest: { lat: 15.029685756555674, lng: -128.67187500000003 },
        precision: "2000km",
        numberOfBuckets: 1000,
        filters: { is_recommended: "true", item_type: "clinic" },
      }
      payload.circle_id = this.currentCircle.id
      if (this.searchName) {
        payload.filters.search_name = name ? name : this.searchName
      }
      medicalDirectoryRepository
        .PostMedicalDirectorySearch(this.currentPage, 3, this.currentCircle.id, "distance", payload)
        .then(res => {
          if (res.data.results) {
            this.ClinicList.results = res.data.results
          } else {
            this.ClinicList.results = []
          }
          this.clinicCount = res.data.totalResults
          this.loadingclinic = false
        })
        .catch(err => {
          this.ClinicList.results = []
          this.loadingclinic = false
        })
    },
    async getHospital(name) {
      console.warn("getHospital()")
      let page = 1
      document.body.scrollTop = 0
      this.loadinghospital = true
      const payload = {
        northEast: { lat: 57.539416794474995, lng: -62.05078125000001 },
        northWest: { lat: 57.539416794474995, lng: -128.67187500000003 },
        southEast: { lat: 15.029685756555674, lng: -62.05078125000001 },
        southWest: { lat: 15.029685756555674, lng: -128.67187500000003 },
        precision: "2000km",
        numberOfBuckets: 1000,
        filters: { is_recommended: "true", item_type: "hospital" },
      }
      payload.circle_id = this.currentCircle.id
      if (this.searchName) {
        payload.filters.search_name = name ? name : this.searchName
      }

      medicalDirectoryRepository
        .PostMedicalDirectorySearchwithRec(this.currentPage, 3, this.currentCircle.id, "distance", payload)
        .then(res => {
          if (res.data.results) {
            this.HospitalList.results = res.data.results
          } else {
            this.HospitalList.results = []
          }
          this.HospitalCount = res.data.totalResults
          this.loadinghospital = false
        })
        .catch(err => {
          this.HospitalList.results = []
          this.loadinghospital = false
        })
    },
    async getNfp(name) {
      console.warn("getNfp()")
      let page = 1
      document.body.scrollTop = 0
      this.loadingnfp = true
      const payload = {
        northEast: { lat: 57.539416794474995, lng: -62.05078125000001 },
        northWest: { lat: 57.539416794474995, lng: -128.67187500000003 },
        southEast: { lat: 15.029685756555674, lng: -62.05078125000001 },
        southWest: { lat: 15.029685756555674, lng: -128.67187500000003 },
        precision: "2000km",
        numberOfBuckets: 1000,
        filters: { is_recommended: "true", item_type: "nfp" },
      }
      payload.circle_id = this.currentCircle.id
      if (this.searchName) {
        payload.filters.search_name = name ? name : this.searchName
      }
      medicalDirectoryRepository
        .PostMedicalDirectorySearch(this.currentPage, 3, this.currentCircle.id, "distance", payload)
        .then(res => {
          if (res.data.results) {
            this.NfpList.results = res.data.results
          } else {
            this.NfpList.results = []
          }
          this.NfpCount = res.data.totalResults
          this.loadingnfp = false
        })
        .catch(err => {
          this.NfpList.results = []
          this.loadingnfp = false
        })
    },

    async getBusiness(name) {
      console.warn("getBusiness()")
      let page = 1
      document.body.scrollTop = 0
      this.loadingBusiness = true
      const payload = {
        northEast: { lat: 57.539416794474995, lng: -62.05078125000001 },
        northWest: { lat: 57.539416794474995, lng: -128.67187500000003 },
        southEast: { lat: 15.029685756555674, lng: -62.05078125000001 },
        southWest: { lat: 15.029685756555674, lng: -128.67187500000003 },
        precision: "2000km",
        numberOfBuckets: 1000,
        filters: { is_recommended: "true", item_type: "Business" },
      }
      payload.circle_id = this.currentCircle.id
      if (this.searchName) {
        payload.filters.search_name = name ? name : this.searchName
      }

      medicalDirectoryRepository
        .PostMedicalDirectorySearch(this.currentPage, 3, this.currentCircle.id, "distance", payload)
        .then(res => {
          if (res.data.results) {
            this.BusinessList.results = res.data.results
          } else {
            this.BusinessList.results = []
          }
          this.BusinessCount = res.data.totalResults
          this.loadingBusiness = false
        })

        .catch(err => {
          this.BusinessList.results = []
          this.loadingBusiness = false
        })
    },
    async applyFilterRole(name) {
      console.warn("applyFilterRole()")
      let page = 1
      document.body.scrollTop = 0
      this.loadingfilter = true
      const payload = {
        northEast: { lat: 57.539416794474995, lng: -62.05078125000001 },
        northWest: { lat: 57.539416794474995, lng: -128.67187500000003 },
        southEast: { lat: 15.029685756555674, lng: -62.05078125000001 },
        southWest: { lat: 15.029685756555674, lng: -128.67187500000003 },
        precision: "2000km",
        numberOfBuckets: 1000,
        filters: { item_type: this.role, is_recommended: "true" },
      }
      payload.circle_id = this.currentCircle.id
      if (this.searchName) {
        payload.filters.search_name = name ? name : this.searchName
      }

      medicalDirectoryRepository
        .PostMedicalDirectorySearch(this.currentPage, 10, this.currentCircle.id, "distance", payload)
        .then(res => {
          if (res.data.results) {
            this.filterList.results = res.data.results
          } else {
            this.filterList.results = []
          }
          this.filterCount = res.data.totalResults
          this.loadingfilter = false
        })
        .catch(err => {
          this.filterList.results = []
          this.loadingfilter = false
        })
    },

    handleClearSearch() {
      this.searchName = ""
      if (this.role !== undefined) {
        this.callroleApi(this.role)
      } else {
        this.callroleApi()
      }
    },

    callDebounce: _.debounce(function() {
      this.currentPage = 1
      if (this.role) {
        this.applyFilterRole(this.searchName)
      } else {
        this.callroleApi()
      }
    }, 500),

    clearFilters() {
      this.role = undefined
      this.callroleApi()
    },

    callroleApi(role) {
      switch (role) {
        case "ohcp":
        case "hcp":
        case "other":
          this.getHcp()
          break
        case "doctor":
        case "physician":
          this.getDoctors()
          break
        case "hospital_administrator":
        case "hospital":
          this.getHospital()
          break
        case "clinic_administrator":
        case "clinic":
          this.getClinic()
          break
        case "nfp_administrator":
        case "nfp":
          this.getNfp()
          break
        case "business":
        case "business_administrator":
          this.getBusiness()
          break
        default: {
          this.getDoctors()
          this.getHcp()
          this.getHospital()
          this.getClinic()
          this.getNfp()
          this.getBusiness()
        }
      }
    },

    getrolename(role) {
      switch (role) {
        case "other healthcare":
          return "Advanced Practice Providers"
        case "physician":
          return "Physicians"
        case "hospital":
          return "Hospitals"
        case "clinic":
          return "Clinics"
        case "nfp_administrator":
        case "nfp":
          return "Non-For-Profits"
        case "Business":
          return "Business"
        default:
          return role
      }
    },

    setCategory(filter = null) {
      this.role = filter !== null ? filter : undefined
      this.pageno = 1
      this.$router.push({ name: "DoveMedRecommendedFilter", query: { role: this.role } })
      this.applyFilterRole()
      // this.getRecommendedUser();
    },
  },
}
</script>

<style lang="scss" scoped>
.results {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #0f1734;
}

.crown-tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 8px;
  gap: 4px;
  width: 30px;
  height: 22px;
  background: #fff0d6;
  border-radius: 4px;
  justify-content: center;
}

.tags-cont {
  display: flex;
  gap: 8px;
}
.rec-tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  width: 115px;
  height: 22px;
  background: #f1edff;
  border-radius: 4px;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  color: #906eff;
}
.recommended-title {
  margin-top: 48px;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #0f1734;
}
.search-container {
  display: flex;
  margin-top: 24px;
  gap: 24px;
  @media screen and (max-width: 428px) {
    flex-direction: column;
  }

  .search-input-state {
    background: none;
    border-left: 0 !important;
    height: 60px;
    outline: none;
    font-weight: 400;
    font-size: 16px;
    line-height: 32px;
    padding: 10px;
    &:focus {
      outline: none;
    }
  }
}
.searchContainer {
  background-color: #f1f5f9 !important;
  border-radius: 8px !important;
  border: none !important;
  input {
    border: none !important;
  }
}

.search-input-state {
  background: none;
  border-left: 0 !important;
  height: 60px;
  outline: none;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;

  &:focus {
    outline: none;
  }
}

.search-button {
  max-width: 60px;
  min-width: 60px;
  border-radius: 8px;
  border: none;
  height: 60px;
  background-color: #f1f5f9 !important;
  &:focus {
    outline: none;
  }

  @media screen and (max-width: 428px) {
    max-width: 100% !important;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }
}

// card
.claim-card {
  border: 1px solid #e2e8f0;
  width: 100%;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  .user-name {
    height: 178px;
    padding: 24px !important;

    .rating-text {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 14px;
      /* or 117% */

      text-align: center;

      /* Gray/900 */

      color: #0f1734;
    }
    .rating-cont {
      margin-top: 11px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0px;
      gap: 4px;
      margin-left: 5px;
      width: 88.53px;
      height: 48px;
    }

    .bg-img {
      position: relative;
      // border: 1px solid #ccc;
      // min-width: 100px;
      max-width: 100px;
      min-height: 70px;
      max-height: 70px;
      width: 70px;
      height: 70px;
      border-radius: 50%;
      display: inline-block;
      margin-left: 11.5px;
      margin-right: 35.5px;

      .rating-badge {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 20%);
        font-size: 15px;
        border-radius: 20px;
        width: 55%;
      }
    }
  }

  .user-address {
    line-height: 15px;
  }

  .dovemed-card-footer {
    border-top: 1px solid rgba(0, 0, 0, 0.125);

    span {
      font-size: 12px;
    }
  }
}
.background-image {
  background-position: center !important;
  background-size: contain !important;
  background-repeat: no-repeat !important;
}
.divider {
  height: 178px;
  border: 1px solid #cbd5e1;
  margin-top: -24px;
  background: #cbd5e1;
}

.first-cont {
  width: 294px;
  display: flex;
  flex-direction: column;
  gap: 17px;
}
.right-items {
  display: flex;
  width: 100%;
  // justify-content: space-between;
  gap: 24px;
  overflow: none !important;
  margin-left: 24px;
  font-size: 14px;

  @media screen and (max-width: 900px) {
    display: block;
  }

  @media screen and (max-width: 600px) {
    display: block;
  }
}
.meet-others {
  display: flex;
  align-items: center;
  width: 283px;
  button {
    margin-right: 24px;
    font-size: 14px;
    border-radius: 6px;
    padding: 12px 24px;
    width: 126px;
    height: 48px;
    font-family: "Lato";
    font-style: normal;
    font-weight: 700;
  }
}
.dovemed-button {
  padding: 12px 45px;
}
.linkbutton {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  gap: 4px;
  background: #f1f5f9;
  border-radius: 8px;
  height: 46px;
  .link-text {
    font-family: "Lato";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    margin-top: 0px;
    margin-bottom: 0px;
  }
}
.card-number {
  display: flex;
  flex-direction: row;
  align-items: end;
  padding: 0px;
  gap: 6px;
  width: 126px;
  height: 24px;
  p {
    margin-bottom: 0;
    margin-left: 0.03px;
    color: #0f1734 !important;
  }
}
.card-location {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  width: 152px;
  height: 42px;
  margin-top: 13.5px;
  gap: 6px;
}
.location-complete {
  height: 42px;
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #94a3b8;
  margin-top: 7px;
}

.location-complete p {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #94a3b8;
  margin-bottom: 0;
  align-items: start;
  display: flex;
  margin-left: 8.5px;
}
.card-distance {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px 0px 0px 28px;
  // height: 21px;
  // margin-top: 12px;
  display: flex;
  align-items: start;
}
.tag {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  .tag-ele {
    padding: 4px 8px;
    display: inline-block;
    font-weight: 700;
    font-size: 10px;
    margin-right: 5px;
    // height: 22px;
  }
}
.review-title {
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #0f1734;
  margin-bottom: 0px;
}

.review-ctn {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 33.5px;
  margin-top: 28px;
}

.pagination-btn {
  padding: 8px;
  gap: 4px;
  width: 790px;
  height: 46px;
  background: #f1f5f9;
  border-radius: 8px;
  border: none;
  align-items: center;
  display: flex;
  justify-content: center;
}

@media screen and (max-width: "769px") {
  .pagination-btn {
    width: 100% !important;
  }
}

.top_filters {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  @media screen and (max-width: 700px) {
    flex-direction: column;
    align-items: flex-start;
  }
}
.filter-container {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}
.filter-text {
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: #0f1734;
  margin-left: 16px;
  @media screen and (min-width: 701px) {
    display: none;
  }
}
.appliedFilter {
  font-weight: 700;
  font-size: 14px;
  color: #647490;
  line-height: 24px;
  @media screen and (max-width: 700px) {
    display: none;
  }
}

.filterTypeBox {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
  gap: 8px;
  background: #f1f5f9;
  border-radius: 6px;

  .filterTypeText {
    font-weight: 700;
    font-size: 14px;
    color: #0f1734;
  }
}

.active-filter-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  align-self: flex-start;
  margin-top: 18px;
  margin-left: 5px;
  @media screen and (min-width: 701px) {
    top: 0;
    right: 0;
    position: absolute;
    margin-right: 10px;
    margin-top: 15px;
  }
}

@media screen and (max-width: 426px) {
  .clear-filters {
    display: flex;
    align-self: center;
  }

  .dovemed-card {
    padding: 8px !important;
    margin: 0 -16px;
  }

  .apply {
    margin-bottom: 0px !important;
    font-family: "Lato";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #0f1734 !important;
    display: block !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/DoveMedRecommended.vue